import {Component, Input, OnInit} from '@angular/core';
import {OrdersHistory} from "../../../../core/models/orders-history";
import {BenefitHistoryType} from "../../../../core/helpers/enums";

@Component({
  selector: 'app-benefit-history-info',
  templateUrl: './benefit-history-info.component.html',
  styleUrls: ['./benefit-history-info.component.scss']
})
export class BenefitHistoryInfoComponent implements OnInit {

  @Input() benefit: OrdersHistory;
  constructor() { }

  ngOnInit(): void {
  }

  isOrderWithAutoOrder() {
    return this.benefit.benefitHistoryType === BenefitHistoryType.Order && this.benefit.isAutoOrderEnabled !== null;
  }

  isOrderWithSubscription() {
    return this.benefit.benefitHistoryType === BenefitHistoryType.Order &&
      this.benefit.subscriptionStatus !== null &&
      this.benefit.subscriptionActualOrders !== null &&
      this.benefit.subscriptionExpectedOrders !== null;
  }

  isSubscription() {
    return this.benefit.benefitHistoryType === BenefitHistoryType.Subscription;
  }

  isAutoOrder() {
    return this.benefit.benefitHistoryType === BenefitHistoryType.AutoOrder;
  }

  isOrder() {
    return this.benefit.benefitHistoryType === BenefitHistoryType.Order &&
      this.benefit.subscriptionStatus === null &&
      this.benefit.isAutoOrderEnabled === null;
  }
}
